import { render, staticRenderFns } from "./ModelDirectMessage.vue?vue&type=template&id=60739643&scoped=true"
import script from "./ModelDirectMessage.vue?vue&type=script&lang=js"
export * from "./ModelDirectMessage.vue?vue&type=script&lang=js"
import style0 from "./ModelDirectMessage.vue?vue&type=style&index=0&id=60739643&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60739643",
  null
  
)

export default component.exports